<template>
    <div class="RiskMannUsuarioNotificacionesNotificacion">
        <div class="card" :class="{
            'bg_alert border border-danger': notificacion.tipo === 'Alerta',
            'bg_reminder border border-warning': notificacion.tipo === 'Recordatorio',
            'opacity': notificacion.esLeida
        }" @click="irNotificacion ? ir(notificacion) : ver(notificacion)">
            <b class="title">{{ notificacion.titulo }}</b>
            <div class="d-flex gap-2">
                <span v-if="notificacion.prioridad" class="badge" :class="{
                    'badge-danger': notificacion.prioridad === 'Alta',
                    'badge-warning': notificacion.prioridad === 'Media',
                    'badge-success': notificacion.prioridad === 'Baja'
                }">
                    Prioridad: {{ notificacion.prioridad }}
                </span>
                <b class="time fw-light">{{ notificacion.registro.creacion }}</b>
            </div>
            <p class="limit_text">{{ notificacion.contenido }}</p>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    name: "RiskMannUsuarioNotificacionesNotificacion",

    props: {
        notificacion: Object,
        irNotificacion: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        ir(notificacion) {
            this.$router.push({
                name: "NotificacionesVer",
                params: {
                    id: notificacion.id
                }
            })
        },

        ver(notificacion) {
            Swal.fire({
                icon: "info",
                title: `<h5 class="fw-bold">${notificacion.titulo}</h5>`,
                html: `
                    <div style="overflow-y: auto !important; overflow-x: hidden !important; max-height: 180px !important;">
                        <p class="text-start me-1" style="white-space: pre-line; white-space: pre-wrap;">${notificacion.contenido}</p>
                    </div>                    
                    <p class="text-start" style="margin-bottom: 0px !important;">
                        <b>Recibida:</b> ${notificacion.registro.creacion}<br/>
                        <b>Leída:</b> ${notificacion.esLeida ? `${notificacion.registro.leida ? notificacion.registro.leida : notificacion.registro.actualizacion}` : 'Pendiente'}
                    </p>
                `,
                buttonsStyling: false,
                showCancelButton: false,
                confirmButtonText: "Entendido",
                reverseButtons: false,
                customClass: {
                    confirmButton: "btn btn-primary btn-md fw-bold me-2"
                },
            });
        }
    }
}
</script>

<style scoped>
.card {
    font-weight: normal;
    max-width: 100%;
    padding: 15px;
    background-color: #f3f3f3;
}

.card .title,
.card .time {
    text-transform: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.card .time {
    font-size: 11pt !important;
}

.card p {
    margin-top: 12px;
    margin-bottom: 0px;
}

.card:hover {
    cursor: pointer;
    transition-duration: 1s;
    border: solid 1px #073d7a !important;
}

.card.bg_alert:hover {
    border: 1px solid #E6423C !important;
}

.card.bg_reminder:hover {
    border: 1px solid #ffc107 !important;
}

.card.opacity {
    opacity: 0.5;
}

.limit_text {
    text-transform: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.bg_alert {
    background: #feebea;
}

.bg_reminder {
    background: #fff0e2;
}
</style>